import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Card = ({ item }) => {
  // destructuring props
  return (
    <>
      <Container>
        <Row>
          <Col>
            <div className="container-fluid">
              <div className="row justify-content-center">
                {item.map((Val) => {
                  return (
                    <div className="col-md-4 col-sm-6 mt-5 mb-5 " key={Val.id}>
                      <div className="card-img-top text-center ">
                        <img
                          src={Val.img}
                          alt={Val.title}
                          className="photo w-100 rounded"
                        />
                      </div>

                      <div className="card-body rounded-bottom">
                        <div className="card-title fw-bold fs-4">
                          {Val.title}
                          <br />
                          <a
                            className="social-media-link"
                            href={Val.website}
                            target="_blank"
                          >
                            {Val.website}
                          </a>
                          {Val.price}
                        </div>
                        <div className="card-text">{Val.desc}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Card;
